/**
 * Tooltip — Dica flutuante ao passar o mouse
 */
import { useState, useRef } from 'preact/hooks';
import { T, CT } from '../../styles/tokens';

interface TooltipProps {
  /** Texto exibido no tooltip */
  text: string;
  /** Posição do tooltip */
  position?: 'top' | 'bottom' | 'left' | 'right';
  /** Elemento filho que aciona o tooltip */
  children: any;
}

const ARROW_SIZE = 6;

export function Tooltip({ text, position = 'top', children }: TooltipProps) {
  const [visible, setVisible] = useState(false);

  // Estilos de posicionamento por direção
  const positionStyles: Record<string, any> = {
    top: { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: ARROW_SIZE + 2 },
    bottom: { top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: ARROW_SIZE + 2 },
    left: { right: '100%', top: '50%', transform: 'translateY(-50%)', marginRight: ARROW_SIZE + 2 },
    right: { left: '100%', top: '50%', transform: 'translateY(-50%)', marginLeft: ARROW_SIZE + 2 },
  };

  // Seta (arrow) por direção
  const arrowStyles: Record<string, any> = {
    top: { bottom: -ARROW_SIZE, left: '50%', transform: 'translateX(-50%)', borderLeft: `${ARROW_SIZE}px solid transparent`, borderRight: `${ARROW_SIZE}px solid transparent`, borderTop: `${ARROW_SIZE}px solid ${T.bgCard}` },
    bottom: { top: -ARROW_SIZE, left: '50%', transform: 'translateX(-50%)', borderLeft: `${ARROW_SIZE}px solid transparent`, borderRight: `${ARROW_SIZE}px solid transparent`, borderBottom: `${ARROW_SIZE}px solid ${T.bgCard}` },
    left: { right: -ARROW_SIZE, top: '50%', transform: 'translateY(-50%)', borderTop: `${ARROW_SIZE}px solid transparent`, borderBottom: `${ARROW_SIZE}px solid transparent`, borderLeft: `${ARROW_SIZE}px solid ${T.bgCard}` },
    right: { left: -ARROW_SIZE, top: '50%', transform: 'translateY(-50%)', borderTop: `${ARROW_SIZE}px solid transparent`, borderBottom: `${ARROW_SIZE}px solid transparent`, borderRight: `${ARROW_SIZE}px solid ${T.bgCard}` },
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div style={{
          position: 'absolute',
          ...positionStyles[position],
          background: CT.tooltip.bg,
          border: `1px solid ${T.border}`,
          borderRadius: CT.tooltip.radius,
          padding: `${T.space1}px ${T.space2}px`,
          color: CT.tooltip.text,
          fontSize: CT.tooltip.fontSize,
          fontWeight: T.weightMedium,
          whiteSpace: 'nowrap',
          zIndex: 10000,
          pointerEvents: 'none',
          boxShadow: CT.tooltip.shadow,
        }}>
          {text}
          <div style={{ position: 'absolute', width: 0, height: 0, ...arrowStyles[position] }} />
        </div>
      )}
    </div>
  );
}
